import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function safeUrlTransform(url) {
  const u = String(url || '').trim().toLowerCase();
  const badScheme = /^(javascript|vbscript|data):/i;
  if (badScheme.test(u)) return '';
  return url;
}

export default function ChalkTalkDrillNotes({ markdown, className }) {
  const text = typeof markdown === 'string' ? markdown : String(markdown ?? '');
  if (!text.trim()) return null;
  // react-markdown v10+ throws if `className` is passed to Markdown — wrap instead.
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        urlTransform={safeUrlTransform}
        components={{
          a: ({ node, children, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
